import { LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import '../../voyage-popup/src/voyage-popup';
import '../../voy-timeinput/src/voy-timeinput';

@customElement('voy-vessel-rs1345-popup')
export class VoyVesselRs1345Popup extends LitElement
{
    @property({type: Boolean}) shown: boolean = false;
    @property({type: String}) displayedHtml: string = '';
    @property({type: String}) address: string = '';

    static get styles()
    {
        return [
            css`
            .container {
                display: flex;
                flex-direction: column;
                margin: 15px;
                align-items: left;
                font-family: MaerskText;
                font-size: 12px;
                background-color: var(--neutrals-grey-10, white);
                color: var(--neutrals-grey-01, black);
            }

            h2 {
                font-family: MaerskText;
                font-size: 14px;
            }

            table {
                width: 100%;
            }

            th {
                text-align: left;
            }

            a {
                display: none;
            }
            `
        ];
    }

    render()
    {
        const innerHtml = document.createRange().createContextualFragment(`${ this.displayedHtml }`);

        return html`
        <voyage-popup accept-button-text="Close" .shown=${this.shown} header-text=${this.address}
                      @accept=${() => this.dispatchEvent(new Event('close'))}
                      @close=${() => this.dispatchEvent(new Event('close'))}
                      .rejectButtonText=${""}>
            <div class="container">
                ${innerHtml}
            </div>
        </voyage-popup>
        `;
    }
};

